import React from "react";
import { TRACK_RECORD_STATS } from "../constants";
import {
  TrackSection,
  TrackBgGradient,
  TrackBgRadial,
  TrackInner,
  TrackBadge,
  TrackTitle,
  TrackLead,
  StatsGrid,
  StatTile,
  StatTileIcon,
  StatTileValue,
  StatTileLabel,
} from "./TrackRecord.styles";

const TrackRecord = () => (
  <TrackSection>
    <TrackBgGradient aria-hidden="true" />
    <TrackBgRadial aria-hidden="true" />

    <TrackInner>
      <TrackBadge>
        <span className="material-icons" aria-hidden="true">
          emoji_events
        </span>
        Proven Since 2017
      </TrackBadge>

      <TrackTitle>
        8+ Years. 3 Bull &amp; Bear Markets.{" "}
        <span>One Trusted Team.</span>
      </TrackTitle>

      <TrackLead>
        Bitcoin Live is the longest running and most successful cryptocurrency
        education service on the market. Through three full bull and bear
        cycles, our analysts have expertly guided members through the
        market&apos;s most volatile and rewarding moments — turning uncertainty
        into opportunity.
      </TrackLead>

      <StatsGrid>
        {TRACK_RECORD_STATS.map((stat) => (
          <StatTile key={stat.label}>
            <StatTileIcon aria-hidden="true">
              <span className="material-icons">{stat.icon}</span>
            </StatTileIcon>
            <StatTileValue>{stat.value}</StatTileValue>
            <StatTileLabel>{stat.label}</StatTileLabel>
          </StatTile>
        ))}
      </StatsGrid>
    </TrackInner>
  </TrackSection>
);

export default TrackRecord;
